import React from 'react';
import {query} from 'api';
import PropTypes from 'prop-types';
import {
  Slide,
  Image,
  SlideText,
  SlideHeadlineMedium,
  Mask,
  MainSlideTitle,
  Button,
  MainTitle as BigTitle,
} from 'ui';
import {SlideTitle} from './styles';
import {getSlugFromUri} from 'lib';

const ArticleSlide = ({data, dossiers_slider_titre, dossiers_slider_url, subTitle, pageTitle}) => {
  if (!data) return null;
  return (
    <Slide>
      <Image src={data.source_url} />
      <Mask />
      <SlideText>
        <SlideTitle>{pageTitle}</SlideTitle>
        <BigTitle>d’accompagnement</BigTitle>
        <SlideHeadlineMedium>{subTitle}</SlideHeadlineMedium>
        <MainSlideTitle>{dossiers_slider_titre}</MainSlideTitle>
        <Button
          to={{
            pathname: `/post/${encodeURIComponent(getSlugFromUri(dossiers_slider_url))}`,
            state: {postURI: dossiers_slider_url},
          }}
          style={{marginTop: 'auto'}}>
          Lire l’article
        </Button>
      </SlideText>
      {/* <p>{pageTitle}</p>
      <p>{subTitle}</p>
      <p>{dossiers_slider_titre}</p>
      <p>{dossiers_slider_url}</p> */}
      {/* <div>imageUrl:</div>
      <div>{data.source_url}</div> */}
    </Slide>
  );
};

ArticleSlide.propTypes = {
  data: PropTypes.object,
  dossiers_slider_titre: PropTypes.string,
  dossiers_slider_url: PropTypes.string,
  pageTitle: PropTypes.string,
  subTitle: PropTypes.string,
};

export default ArticleSlide |> query('getPost', {loadingHidden: true});
